
import NotificationItem from "./NotificationItem";
import "./Notifications.css";

function NotificationsList({ notifications = [], onClick }) {
    if (notifications.length === 0) {
        return (
            <div className="notifications-empty">
                <svg
                    className="notifications-empty__icon"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                >
                    <path
                        d="M17 8H29"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                    />
                    <path
                        d="M17 18H29"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                    />
                    <path
                        d="M17 28H29"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                    />
                    <rect
                        x="3.5"
                        y="4"
                        width="5"
                        height="5"
                        rx="1"
                        stroke="currentColor"
                        strokeWidth="2.5"
                    />
                    <rect
                        x="3.5"
                        y="14"
                        width="5"
                        height="5"
                        rx="1"
                        stroke="currentColor"
                        strokeWidth="2.5"
                    />
                    <rect
                        x="3.5"
                        y="24"
                        width="5"
                        height="5"
                        rx="1"
                        stroke="currentColor"
                        strokeWidth="2.5"
                    />
                    <circle
                        cx="26"
                        cy="9"
                        r="5"
                        fill="white"
                        stroke="currentColor"
                        strokeWidth="2.5"
                    />
                    <path
                        d="M30 13L33 16"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                    />
                </svg>
                Não existem notificações.
            </div>
        );
    }
    const clickItem = (id) => {
        onClick(id)
    }

    return (
        <section className="notifications-list">
            {notifications.map((notification) => (
                <NotificationItem
                    key={notification.id}
                    notification={notification}
                    onClick={() => clickItem(notification.id)}
                />
            ))}
        </section>
    );
}

export default NotificationsList;